import { getStorage, setStorage } from "../../helpers/storage";
import { modal } from "../../functions/modal";
import axios from '../../helpers/axiosConfig';
export function survey() {
    const widgets = document.querySelectorAll('.survey-widget');
    if (!widgets)
        return;
    const init = (widget) => {
        const results = widget.querySelector('.survey-results');
        const form = widget.querySelector('form');
        const surveyId = form.getAttribute('data-surveyid');
        const url = form.getAttribute('data-url');
        if (getStorage('surveys_voted') != null) {
            const voted = getStorage('surveys_voted').split(";");
            if (voted.indexOf(surveyId.toString()) > -1) {
                form.style.display = 'none';
                results.style.display = 'block';
            }
        }
        form.addEventListener('submit', e => {
            e.preventDefault();
            const answers = [];
            const checkboxes = form.querySelectorAll('input:checked');
            checkboxes.forEach(checkbox => {
                answers.push(checkbox.value);
            });
            axios.post(url, { answers }).then((response) => {
                const voted = getStorage('surveys_voted');
                setStorage('surveys_voted', voted + ';' + surveyId);
                const message = document.createElement('div');
                message.innerHTML = response.data;
                modal(__('Ankieta'), message, 'icon--info-alt');
                form.style.display = 'none';
                results.style.display = 'block';
            });
        });
    };
    widgets.forEach(widget => {
        init(widget);
    });
}
